import type { Message, MessageCreate } from './types';
import type { ReactNode } from 'react';
import type { AlertLevel } from 'src/interface/command-center/unsorted-types';
import type { Options } from 'src/tools/http/renderErrorMessaging';
import noop from 'lodash/noop';
import { createContext } from 'react';

type LEGACY_MessageCreate = {
  type: AlertLevel;
  overridable?: boolean;
  text: ReactNode;
};

type MessagesState = {
  messages: Message[];
  showMessage: (message: MessageCreate) => string;
  showError: (
    options: { error: unknown } & Options &
      Omit<MessageCreate, 'type' | 'title' | 'errorMessage'>,
  ) => string;
  LEGACY_showMessage: (message: LEGACY_MessageCreate) => string;
  dismissMessage: (id: string) => void;
};

const defaultState: MessagesState = {
  messages: [],
  showMessage: () => '',
  showError: () => '',
  LEGACY_showMessage: () => '',
  dismissMessage: noop,
};

export const MessagesContext = createContext<MessagesState>(defaultState);
export type { MessagesState };
